// Create a map of users to easily assign each one to its group
export function createUsersMap(users = []) {
  return users.reduce((map, user) => {
    map[user.id] = {
      ...user,
      label: user.name,
    };

    return map;
  }, {});
}

export function createGroupTree(groups = [], parent = null, usersMap = {}) {
  return groups
    .filter((group) => group.parent === parent)
    .map((group) => {
      // create subGroups recursively
      const subGroups = createGroupTree(groups, group.id, usersMap);

      // Users of a current group
      const usersInGroup = (group.ad_users || [])
        .map((userId) => {
          const user = usersMap[userId];

          if (!user?.id) {
            return null;
          }

          return {
            ...user,
            value: `d${group.domain}-g${group.id}-u${user.id}`,
          };
        })
        .filter(Boolean); // filter null values

      return {
        ...group,
        label: group.name,
        value: `d${group.domain}-groupId${group.id}`,
        children: [...subGroups, ...usersInGroup],
      };
    });
}

export function createTree(domains = [], groupsTree = []) {
  return domains.map((domain) => ({
    ...domain,
    value: `domain-${domain.id}`,
    label: domain.name,
    children: groupsTree.filter((group) => group.domain === domain.id),
  }));
}
